import { EditProfileType, GetProfileType, IVerifyAuth } from "./types";

export const getProfileSlr = (state: any): GetProfileType => state.account.getProfileState;
export const editProfileSlr = (state: any): EditProfileType => state.account.editProfileState;
export const verifyAuthSlr = (state: any): IVerifyAuth => state.account.verifyAuthState;
